module.exports = __webpack_public_path__ + "img/sword-fire-06.c41af72f.png";